@use "../../styles/breakpoint.module.scss" as *;

.row {
    border-bottom: 1px solid rgb(var(--white-gray-base));
    display: flex;
    font: var(--font-p-16);
    margin-bottom: var(--spacer-16);
    padding-bottom: var(--spacer-16);
}

.time {
    font: var(--font-p-14);
    padding-right: 24px;
    font-weight: 700;
    letter-spacing: 0.1em;
    padding-top: 2px;
}
